import AsyncStorage from "@react-native-async-storage/async-storage";
import { clientConfigPath, clientConfigPosBaseEndPoint } from "../../config/Constant";
import { setHcommerceStoreSkuData } from "../Reducers/hcommerceReducer";
import { setRenderFlashMessage } from "./appConfigAction";
import { wipeGuestData } from "../../js/wipeGuestData";

export const fetchStoreInfo = (sku) => {


    if (!sku) {
        return { status: "ERROR", message: "Store sku not provided" };
    }

    return async (dispatch, getState) => {

        try {
            const { hcommerceStoreSkuData } = getState().storeInfoSlice;
            const sessionToken = await AsyncStorage.getItem('sessionToken');
            const room = await AsyncStorage.getItem('room');

            const payload = {
                header: {
                    sessionToken: sessionToken,
                },
                payload: {
                    storeSku: sku,
                    locationId: 1,
                },
            };

            const response = await clientConfigPath.post("/storeInfo/fetch/v2", payload);

            if (response.data?.header?.status?.statusCode === "SUCCESS") {
                console.log('Store Info Fetch Success');

                let existingData = hcommerceStoreSkuData[sku] || {};

                // New API response structure has storeData, configs, and posType at payload level
                const { storeData, configs, posType } = response.data.payload;

                const updatedStoreData = {
                    [sku]: {
                        ...existingData,
                        storeData: storeData,
                        configs: configs,
                        posType: posType
                    }
                };

                dispatch(setHcommerceStoreSkuData(updatedStoreData));
                return { status: "SUCCESS" }
            } else {
                console.error('API returned failure status:', response.data);

                return { status: "ERROR", message: response.data?.header?.status?.msg || "Something went wrong" }
            }
        } catch (error) {
            console.error('Error fetching store info:', error);
            return { status: "ERROR", message: "Something went wrong" };
        }
    };
};



export const placeHcomOrder = (storeSku, orderDetails) => {


    return async (dispatch, getState) => {

        const { currentGuestDetails } = getState().guestDetailsSlice;

        const sessionToken = await AsyncStorage.getItem("sessionToken");

        const body_header = {
            dataSource: "guestJourney",
            guestEmail: orderDetails.guestEmail || currentGuestDetails?.guestProfile?.email || "",
            guestToken: currentGuestDetails?.guestToken || "",
            locationId: currentGuestDetails?.location || "",
            loggedinGuestToken: currentGuestDetails?.guestToken || "",
            sessionToken: sessionToken
        }

        const body_payload = {
            storeSku: storeSku,
            guestReservationNumber: currentGuestDetails?.reservationNumber,

            gratitudeTipValue: orderDetails.gratitudeTipValue,
            guestComment: orderDetails.guestComment,
            guestCount: orderDetails.guestCount,
            orderDeliveryAt: orderDetails.orderDeliveryAt,
            orderDeliveryLocationImage: orderDetails.orderDeliveryLocationImage,
            orderDeliveryLocationURL: orderDetails.orderDeliveryLocationURL,
            orderDeliveryTime: orderDetails.orderDeliveryTime,
            orderDetails: { orderItemsList: orderDetails.orderItemsList },
        }



        try {

            const response = await clientConfigPath.post("/storeItems/order", {
                header: body_header,
                payload: body_payload,
            });

            console.log("Order API response:", response);

            const status = response?.data?.header?.status?.code;

            if (status == "SUCCESS") {
                dispatch(setRenderFlashMessage(true, { type: "success", message: "Order placed successfully!!" }));
                return { status: "SUCCESS" };
            } else {
                dispatch(setRenderFlashMessage(true, { type: "danger", message: response?.data?.header?.status?.msg || "Something went wrong" }));
                return { status: "ERROR", message: response?.data?.header?.status?.msg || "Something went wrong" };
            }

        } catch (error) {
            console.error("Error in sendOrder API:", error);
            dispatch(setRenderFlashMessage(true, { type: "danger", message: error.response?.data?.header?.status?.msg || "Something went wrong" }));
            return { status: "ERROR", message: error.response?.data?.header?.status?.msg || "Something went wrong" };
        }
    };
};

export const getToastPricing = async (payload, callback) => {
  try {
    console.log("calling getToastPricing", JSON.stringify(payload));
    

    await clientConfigPosBaseEndPoint.post("/toast/fetchOrderPrice", payload)
      .then((response) => {

        console.log("fetchOrderPrice Response: ", response);

        if (response && response.data && response.data.header.status.code === "SUCCESS") {
          if (callback) callback(true, response.data.payload);
        } else {
          if (callback) callback(
            false,
            response?.data?.header?.status?.msg || 
            response?.data?.header?.status?.message ||
            "Failed to fetch pricing"
          );
        }
      })
      .catch(({ response = {} }) => {

        if (response.status == 401) {
          wipeGuestData({ inRoomTab: process.env.REACT_APP_INROOMTAB == "true" });
        }

        console.log("fetchOrderPrice api failed with status code:", response.status, response);

        if (callback) callback(
          false,
          response?.data?.header?.status?.msg || 
          response?.data?.header?.status?.message ||
          "API request failed"
        );
      });
  } catch (e) {
    console.log("error in fetchOrderPrice api", e);
    if (callback) callback(false, "Something went wrong.");
  }
};